<template>
  <div>
    <div class="text-center mt-3">
      <h1>{{ detailTimesheet.percentageFinishedTask }}%</h1>
      <div>
        Today, {{ $moment().format('DD MMM YYYY') }}
      </div>
      <div>
        {{ detailTimesheet.finishedTaskCount }} Task out of {{ detailTimesheet.allTaskCount }}
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    detailTimesheet: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('jStoreHome', ['timesheet_detail']),
  },

  methods: {
    ...mapActions('jStoreHome', ['getTimesheetDetail', 'getOrganigramId']),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jTimesheetWidget.vue